import axios from "axios";

export const externalApi = axios.create({
  timeout: 45_000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export function getExternalErrorMessage(err: any) {
  return (
    err?.response?.data?.message ||
    err?.response?.data?.error?.message ||
    err?.message ||
    "Something went wrong. Please try again."
  );
}
